export default __webpack_public_path__ + "static/media/S30.7f1d10ad.png";